import { MdOutlineCalendarMonth } from 'react-icons/md';
import { BsReverseListColumnsReverse } from 'react-icons/bs';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';

const tiles = [
  {
    sNo: 1,
    link: '/common/callibrationplanlist',
    isLink: true,
    icon: <MdOutlineCalendarMonth size="5rem" color="#343a40" />,
    p: 'CALLIBRATION',
    span: 'PLAN',
    isIcon: true,
  },

  {
    sNo: 2,
    link: '/common/callibrationchecklistList',
    isLink: true,
    icon: <BsReverseListColumnsReverse size="5rem" color="#087f5b" />,
    p: 'CALLIBRATION',
    span: 'STATUS',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="CALLIBRATION" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
